/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: Rehabilitation_Data_Entrie_Page.js
 *  @description: Этот файл является частью клиентской стороны проекта. src Относится к части, которая содержит существенную часть проекта - страницы атласа. Категория "Реабилитация". В этом файле находится содержимое страницы, которая выводится при переходе на страницу кейса конкретной категории.
 *	@author: Белов Михаил Александрович, Горбас Александр Петрович
 */


import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Context } from "../../index";
import { observer } from 'mobx-react-lite';
import { PrepareItemPage } from '../../utils/PageDataPrepare';
import TopCaseNavigation from '../../components/TopCaseNavigation';
import BottomCaseNavigation from '../../components/BottomCaseNavigation';
import { Rehabilitation_EntriesPerPage } from './Rehabilitation_Categories_Page';
import VideoSlider from '../../components/VideoSlider';

const Rehabilitation_Data_Entrie_Page = observer(() => {
    const { user } = useContext(Context);
    const { t } = useTranslation();
    const [pageData, setPageData] = useState({});
    const location = useLocation();
    const [videoUrls, setVideoUrls] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            const data = await PrepareItemPage(location, user.language, Rehabilitation_EntriesPerPage);

            // Обработка видео
            let processedVideos = [];
            if (data?.item?.video_path) {
                // Если video_path - строка, преобразуем в массив
                if (typeof data.item.video_path === 'string') {
                    processedVideos = data.item.video_path
                        .split('|')
                        .map(path => path.trim())
                        .filter(path => path.length > 0)
                        .map(path => path.startsWith('/') ? path : `/${path}`);
                }
                // Если video_path уже массив
                else if (Array.isArray(data.item.video_path)) {
                    processedVideos = data.item.video_path
                        .map(path => typeof path === 'string' ? path.trim() : '')
                        .filter(path => path.length > 0)
                        .map(path => path.startsWith('/') ? path : `/${path}`);
                }
            }

            setPageData({
                ...data,
                item: {
                    ...data.item,
                    description: {
                        ru: data.item.description_ru?.split('|') || [],
                        en: data.item.description_en?.split('|') || [],
                    },
                },
            });
            setVideoUrls(processedVideos);
        };

        loadData();
    }, [location, user]);

    if (!pageData || !pageData?.category || !pageData?.item) {
        return null;
    }

    return (
        <div className='rehabilitation_page_block'>
            <div className='page_content_title'>
                <img className='page_title_icon' src='/icons/rehabilitation_icon.png' alt='page_title_icon' />
                {t('rehabilitation_title')}
            </div>
            <div className="flex_container" key={pageData.item.id}>
                <div className='flex_container_title'>
                    <div className='item flex_item_1'>
                        {pageData.item['name_' + user.language]}
                    </div>
                    <TopCaseNavigation className='top_case_navigation_block' pageData={pageData} />
                </div>

                <hr />
                <br />

                {videoUrls.length > 0 && (
                    <div className="video-section">
                        <VideoSlider
                            id={pageData.item.id}
                            videos={videoUrls}
                            descriptions={pageData.item.description}
                            language={user.language}
                            onSlideChanged={() => {}}
                        />
                    </div>
                )}

                <BottomCaseNavigation pageData={pageData} />
            </div>
        </div>
    );
});

export default Rehabilitation_Data_Entrie_Page;